/** Decodes JWT payload (client-side only; not signature verification). */
export function readJwtPayload(accessToken: string): Record<string, unknown> | null {
  try {
    const parts = accessToken.split('.');
    if (parts.length < 2) {
      return null;
    }
    const segment = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = segment.length % 4 === 0 ? '' : '='.repeat(4 - (segment.length % 4));
    const json = atob(segment + pad);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Wasel access tokens carry the `id` claim (user or platform operator GUID). */
export function readUserIdFromAccessToken(accessToken: string): string | null {
  const payload = readJwtPayload(accessToken);
  const id = payload?.['id'];
  return typeof id === 'string' && id.length > 0 ? id : null;
}
